import gql from 'graphql-tag';

export const CreateFeedback = gql`
  mutation createFeedback($feedback: FeedbackCreate!) {
    createFeedback(feedback: $feedback) {
      id
    }
  }
`;
